import { render, staticRenderFns } from "./CreateBoardModalComponent.vue?vue&type=template&id=273af818&"
import script from "./CreateBoardModalComponent.vue?vue&type=script&lang=ts&"
export * from "./CreateBoardModalComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('273af818')) {
      api.createRecord('273af818', component.options)
    } else {
      api.reload('273af818', component.options)
    }
    module.hot.accept("./CreateBoardModalComponent.vue?vue&type=template&id=273af818&", function () {
      api.rerender('273af818', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/Board/CreateBoardModalComponent.vue"
export default component.exports